<template>
  <div style="margin-left: 40px">
    <h3>{{this.title}}</h3>
    <q-card class="my-card">
      <q-card-actions class="header">
        <div color="primary">
           {{$gettext('ADDRESS') + ' ' + cardTypeDesc}}
          <q-icon :name="icon" size="23px"/>
        </div>
        <div>
          <q-btn flat @click="() => $emit('open-map', this.data)">
            <q-icon name="pin_drop"
                    size="25px" />
          </q-btn>
          <q-btn flat id="btn-editar-endereco" @click="() => $emit('edit', this.data)">
            <q-icon name="edit"
                    size="25px" />
          </q-btn>
        </div>
      </q-card-actions>
      <q-card-section class="bg-ice card-selection">
        <span class="text-subtitle2" style="width: 100%">
          {{$gettext('ADDRESS') }}:
          <span class="text-subtitle1">{{[data.address_name,data.number].filter(Boolean).join(',')}}</span>
        </span>
      </q-card-section>
      <q-card-section class="card-selection">
        <span class="text-subtitle2" style="width: 100%">
          {{$gettext('ADDRESS_NEIGHBORHOOD') }}:
          <span class="text-subtitle1">{{data.address_neighborhood_name}}</span>
        </span>
      </q-card-section>
      <q-card-section class="bg-ice card-selection">
        <span class="text-subtitle2" style="width: 100%">
          {{$gettext('ZIP') }}:
          <span class="text-subtitle1">{{data.zipCode}}</span>
        </span>
      </q-card-section>
      <q-card-section class="card-selection">
        <span class="text-subtitle2" style="width: 100%">
          {{$gettext('CITY') }}:
          <span class="text-subtitle1">{{data.address_neighborhood_city_name}}</span>
        </span>
      </q-card-section>
      <q-card-section class="bg-ice card-selection">
        <span class="text-subtitle2" style="width: 100%">
          {{$gettext('ADDRESS_STATE') }}:
          <span class="text-subtitle1">{{data.address_neighborhood_city_state_uf }}</span>
        </span>
      </q-card-section>
      <q-card-section class="card-selection">
        <span class="text-subtitle2" style="width: 100%">
          {{$gettext('COMPLEMENT') }}:
          <span class="text-subtitle1">{{data.detail}}</span>
        </span>
      </q-card-section>

    </q-card>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'

const { pageDetail } = JtCrud

@Component({
  mixins: [pageDetail],
  name: 'AddressUnitCard',
  components: {
    pageDetail
  },
  props: {
    data: Object,
    ownershipChange: Boolean
  }
})
class AddressUnitCard extends Vue {
  get title () {
    return this.data.addressPersonType == 20030001
      ? this.$gettext('MAIN_PHYSICAL_ADDRESS')
      : this.$gettext('OTHER_ADDRESS')
  }

  get cardTypeDesc () {
    return this.data.addressPersonTypeDesc
  }

  get icon () {
    if (this.data.addressPersonType == 20030001) {
      return 'home'
    } else if (this.data.addressPersonType == 20030002) {
      return 'mail'
    } else {
      return 'attach_money'
    }
  }
}
export default AddressUnitCard
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
.my-card {
  width: 72vh;
  height: 300px;
  margin: 0px 10px 20px 0px !important;
  padding: 15px !important;
}
.text-subtitle1 {
  color: $light-d;
}
h3 {
  font-size: 20px;
  margin: 0;
  color:$light-d;
}
.container {
  margin-left: 40px
}
.header {
  padding: 0;
  display: flex;
  justify-content:space-between;
}
.card-selection {
  padding: 0 11px;
  height: 38px;
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items: center
}
</style>
